export default __webpack_public_path__ + "static/media/calendar.1d61669d.svg";